module.exports = __webpack_public_path__ + "static/media/xplore-logo2.6fe033a3.jpg";